export const IMAGE_KIT_URL_ENDPOINT =
  "https://images.trackmangolf.com/golf-on-course-app";

export const HOME_PAGE_VIDEO_TRANSFORMATION = "w-1280,q-75";

const HOME_PAGE_VIDEO_PATHS = [
  "/showcase/home-page-video-1.mp4",
  "/showcase/home-page-video-2.mp4",
  "/showcase/home-page-video-3.mp4",
  "/showcase/home-page-video-4.mp4",
  "/showcase/home-page-video-5.mp4",
  "/showcase/home-page-video-6.mp4",
] as const;

export function buildHomePageVideoUrl(path: string): string {
  const base = `${IMAGE_KIT_URL_ENDPOINT}${path}`;
  return `${base}?tr=${HOME_PAGE_VIDEO_TRANSFORMATION}`;
}

export const HOME_PAGE_VIDEO_URLS = HOME_PAGE_VIDEO_PATHS.map((path) =>
  buildHomePageVideoUrl(path)
) satisfies string[];

export const VG_IMAGE_MAP_MAX_SCALE = 2.5;
